export default "__VITE_ASSET__$Gl0d3wI__"